import { render } from "./CardVisa.vue?vue&type=template&id=62997576"
const script = {}

import exportComponent from "../../../../Mamolico/NcS02D02JpStore/WebApp/Mamolico/NcS02D02JpStore/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__